module.exports = __webpack_public_path__ + "static/media/photo245.a0f53e8a.jpg";